<template>
  <!-- Main modal -->
  <div v-cloak>
    <transition name="modal">
      <div
        v-show="visible"
        class="modal flex justify-center items-center h-screen w-screen fixed top-0 left-0 font-normal text-md"
      >
        <div
          v-click-away="clickaway"
          class="modal-content relative max-w-[740px] h-screen md:h-auto p-6 py-16 md:p-16"
        >
          <button
            class="absolute right-8 top-3 fill-current text-2xl font-medium font-sans"
            @click="hidePopup()"
          >
            x
          </button>
          <h2 class="text-2xl md:text-3xl text-center mb-16 font-sans font-medium">
            {{ header }}
          </h2>
          <div class="modal-body">
            <slot />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { useStore } from 'vuex'
const store = useStore()
const bgColor = store.state.config.backgroundColor

defineProps({
  header: { type: String, default: null },
  visible: Boolean,
})

const emit = defineEmits(['close'])

const hidePopup = () => {
  emit('close')
}

const clickaway = e => {
  if (e.target.classList.contains('modal')) {
    hidePopup()
  }
}
</script>

<style>
.modal-body p {
  @apply mb-4;
}
</style>

<style scoped>
.modal {
  z-index: 9998;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: v-bind(bgColor);
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

/* Transitions */
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
</style>
